<form class="home-container" *ngIf="userFormGroup" [formGroup]="userFormGroup" (submit)="submitFormData()">
  <div class="header-section">
    <div class="title">{{ 'app.user-form.login' | translate }}</div>
    <i class="pi pi-times icon-buttons" (click)="closeDialog()"></i>
  </div>
  <div class="content-section">
    <div class="field-rows">
      <input
        class="ui-input pInputText input-field"
        id="login-input-email"
        formControlName="email"
        pInputText
        placeholder="{{ 'app.user-form.email' | translate }}"
        size="30"
        type="text" />
    </div>
    <div class="field-rows">
      <input
        class="ui-input pInputText input-field"
        id="login-input-password"
        formControlName="password"
        pPassword
        placeholder="{{ 'app.user-form.password' | translate }}"
        size="30"
        type="password"
        [showPassword]="showPassword"
        [feedback]="false" />
      <span class="show-password-container">
        <i [ngClass]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="showPassword = !showPassword"></i>
      </span>
    </div>

    <div class="login-submit-button-section">
      <p-button
        class="full-width-button"
        id="login-btn-submit"
        icon="{{ isLoading ? 'pi pi-spin pi-spinner' : 'null' }}"
        iconPos="right"
        type="submit"
        [disabled]="userFormGroup.invalid"
        [label]="'app.user-form.login-button' | translate"></p-button>
    </div>
    <div class="error-message" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

    <div class="footer">
      <span class="login-section">
        <div class="reset-button" (click)="showResetForm()">{{ 'app.user-form.forgot-password' | translate }}</div>
        <!-- <p-button (click)="showResetForm()"
                  id="reset-btn"
                  class="reset-button full-width-button"
                  [label]="'app.user-form.reset-button' | translate"></p-button> -->
        <div>{{ 'app.user-form.goto-register' | translate }}</div>
        <p-button
          (click)="showRegistrationForm()"
          id="login-btn-register"
          class="register-button full-width-button"
          [label]="'app.user-form.registration-button' | translate"></p-button>
      </span>
    </div>
  </div>
</form>
